import type { ComponentProps, ReactNode } from 'react'
import { colClass, type ColSpan } from '@/components/console/classes'
import { cn } from '@/lib/utils'

interface CardProps extends ComponentProps<'div'> {
  /** Make the card a grid cell of `<Grid>`. */
  span?: ColSpan
}

/** A panel (`.card`): surface, 1px line, 10px radius, 22px padding (18px on mobile). */
export function Card({ span, className, children, ...props }: CardProps) {
  return (
    <div className={cn('card', span && colClass(span), className)} {...props}>
      {children}
    </div>
  )
}

interface CardHeaderProps {
  title: ReactNode
  /** Quiet note beside the title (`.panelnote`). */
  note?: ReactNode
  /** After the spacer, on the right: badges, a small button. */
  actions?: ReactNode
  /** Next to the title, before the note, e.g. a count. */
  children?: ReactNode
  className?: string
}

/** The card's head row (`.card-h`) with its h2. */
export function CardHeader({ title, note, actions, children, className }: CardHeaderProps) {
  return (
    <div className={cn('card-h', className)}>
      <h2>{title}</h2>
      {children}
      {note ? <span className="panelnote">{note}</span> : null}
      {actions ? (
        <>
          <span className="sp" />
          {actions}
        </>
      ) : null}
    </div>
  )
}
